webpackJsonp([66023823850927],{

/***/ 1552:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"SaveTreatmentSheetCellOrderItemInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"quantity","type":{"kind":"SCALAR","name":"Decimal","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-save-treatment-sheet-cell-order-item-input-3e117221e9462b9eb116.js